import React from 'react';
import {
  Box,
  Container,
  Typography,
  Button,
  Grid,
  Paper,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import PageLayout from '../../components/PageLayout';

const PageTitle = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '3rem',
  color: '#1a1a1a',
  marginBottom: '2rem',
  textAlign: 'center',
});

const StorySection = styled(Paper)({
  padding: '2rem',
  marginBottom: '2rem',
  backgroundColor: '#fff',
  boxShadow: 'none',
  border: '1px solid #eee',
  borderRadius: '8px',
});

const StoryText = styled(Typography)({
  fontSize: '1.1rem',
  lineHeight: '1.8',
  color: '#333',
  marginBottom: '1.5rem',
});

const YearText = styled(Typography)({
  fontFamily: 'Cormorant Garamond, serif',
  fontSize: '2.5rem',
  color: '#c4a661',
  marginBottom: '1rem',
});

const CustomButton = styled(Button)({
  backgroundColor: '#1a1a1a',
  color: '#fff',
  padding: '1rem 2rem',
  marginTop: '2rem',
  '&:hover': {
    backgroundColor: '#c4a661',
  },
});

const OurStoryPage = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <Container>
        <Box sx={{ py: 8 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <PageTitle>Our Story</PageTitle>

            <Grid container spacing={4}>
              <Grid item xs={12}>
                <StorySection>
                  <YearText>Established in 2022</YearText>
                  <StoryText>
                    Custom Connect Jewelry was born from a vision to revolutionize the jewelry industry. 
                    We're tired of seeing the same concepts passed around from jeweler to jeweler. Our mission 
                    is to break free from the conventional and create pieces that are truly unique and extraordinary.
                  </StoryText>
                  <StoryText>
                    At Custom Connect Jewelry, we strive to make one-of-a-kind, priceless pieces that you won't 
                    find anywhere else. Each creation is a testament to our commitment to originality and 
                    craftsmanship, designed to tell your unique story.
                  </StoryText>
                </StorySection>
              </Grid>

              <Grid item xs={12}>
                <StorySection>
                  <Typography variant="h4" gutterBottom sx={{ 
                    fontFamily: 'Cormorant Garamond, serif',
                    color: '#1a1a1a',
                    marginBottom: '1.5rem'
                  }}>
                    Custom Creations
                  </Typography>
                  <StoryText>
                    Our passion lies in creating bespoke pieces that reflect your individual style and story. 
                    Whether you're dreaming of a unique engagement ring, a special anniversary piece, or a 
                    statement jewelry item that's uniquely yours, our expert craftsmen are here to bring your 
                    vision to life.
                  </StoryText>
                  <CustomButton
                    onClick={() => navigate('/contact')}
                    variant="contained"
                  >
                    Inquire About Customs
                  </CustomButton>
                </StorySection>
              </Grid>

              <Grid item xs={12}>
                <StorySection>
                  <Typography variant="h4" gutterBottom sx={{ 
                    fontFamily: 'Cormorant Garamond, serif',
                    color: '#1a1a1a',
                    marginBottom: '1.5rem'
                  }}>
                    Our Promise
                  </Typography>
                  <StoryText>
                    We promise to continue pushing boundaries and challenging the status quo in jewelry design. 
                    Every piece that leaves our workshop is crafted with meticulous attention to detail and a 
                    commitment to excellence that sets us apart in the industry.
                  </StoryText>
                  <StoryText>
                    Join us in our journey to redefine luxury jewelry, where each piece is not just an accessory, 
                    but a work of art that tells a story.
                  </StoryText>
                </StorySection>
              </Grid>
            </Grid>
          </motion.div>
        </Box>
      </Container>
    </PageLayout>
  );
};

export default OurStoryPage;
